import {
    NSHIFT_SET_POSTALCODE,
    NSHIFT_SET_DELIVERYOPTIONS_ISFETCHED,
    NSHIFT_SET_CRANE_WARNING_MESSAGE,
    NSHIFT_SET_SELECTED_OPTION
} from '../constants';

const initState = {
    postalCode: '',
    canUnload: false,
    isFetched: false,
    showWarningMessage: false
}

export const nshift = (state = initState, action) => {
    switch (action.type) {
        case NSHIFT_SET_POSTALCODE:
        case NSHIFT_SET_DELIVERYOPTIONS_ISFETCHED:
        case NSHIFT_SET_CRANE_WARNING_MESSAGE:
        case NSHIFT_SET_SELECTED_OPTION:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
};
